
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/apipages/common-formats",
      function () {
        return require("private-next-pages/apipages/common-formats/index.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/apipages/common-formats"])
      });
    }
  